import React from 'react'

export function InvoiceParticularsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #show-customer-link {
          color: blue;
          border: none;
          padding: 2px 3px;
        }
        #show-customer-link:hover { text-decoration: underline; }

        .tbody-items-group { color: #202020; }

        /** Animate the invoice particular item */
        .decolorize {
          color: #202020;
          animation: blurring 3s;
        }
        @keyframes blurring {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        #ip-action-buttons-container {
          display: flex;
          padding: 5px;
          flex-direction: column;
        }
        #ip-item-remarks {
          font-size: 0.7em;
        }
        #invoice-particulars-container { padding: 5px; }
        #invoice-particulars-items-table-container { }
        #invoice-particulars-form-table { background-color: #F0F2F8; }
        .table-container {
          display: flex;
          flex-direction: column;
        }
        .table-container table {
          border: 1px lightgrey solid;
          padding: 5px;
          width: 100%;
        }
        .thead-header-group th {
          padding: 5px;
          text-align: left;
        }
        .tbody-items-group td {
          padding: 5px;
        }
        .thead-input-group th {
        }
        .invoice-particulars-table th:nth-child(2), td:nth-child(2) {
          width: 40%;
        }
        .invoice-particulars-table th:nth-child(3), td:nth-child(3) {
          width: 20%;
        }
        .invoice-particulars-table th:nth-child(4), td:nth-child(4) {
          width: 10%;
        }
        .invoice-particulars-table th:nth-child(5), td:nth-child(5) {
          width: 10%;
        }
        .invoice-particular-input {
          box-sizing: border-box;
          padding: 8px;
          border: solid 1px lightgrey;
          width: 100%;
          height: 33px;
        }

        /*DROP DOWN MENU LIKE*/
        .action-btn-menu {
          position: absolute;
          top: 0;
          left: -65px;
          display: flex;
          justify-content: center;
          text-align: center;
          border-radius: 3px;
          font-size: 0.7em;
          z-index: 1;
          display: none;
        }
        .dd-menu { position: relative; }
        .show-dd-menu { display: flex; }

        .pospro-action-btn.edit-row-btn {
          background-color: rgba(0, 255, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.edit-row-btn:hover { background-color: rgba(0, 205, 0, 1); }

        .pospro-action-btn.del-row-btn {
          background-color: rgba(255, 0, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.del-row-btn:hover { background-color: rgba(205, 0, 0, 1); }
        /*DROP DOWN MENU LIKE END*/

        #item_name-acl-container #autocomplete-list {
           /*bottom: 50%;*/
           margin-bottom: 33px;
         }

        /* SEARCH INPUT NOT FOUND ITEM */
        .not-found {
          border: solid 2px red;
          background-color: lightgrey;
          color: darkgrey;
        }
        .not-found:focus {
          background-color: white;
          border: solid 0.5px lightblue;
          color: black;
        }
        /* SEARCH INPUT NOT FOUND ITEM END */

        .highlight-item-details-row {
          background-color: lightblue;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function InvoiceSummaryStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #invoice-summary-container {
          padding: 2px;
          flex: 2;
        }
        #invoice-summary-container .form-input-container {
          flex-direction: column;
        }
        #invoice-summary-container .form-input-container label {
          color: darkgrey;
          font-weight: normal;
        }
        #invoice-summary-container .form-input-container .input {
          padding: 5px;
          font-size: 1em;
          color: whitesmoke;
          text-align: right;
          background-color: transparent;
          border-bottom: 0;
          border-right: 0;
          border-left: 0;
          border-top: 1px rgba(25, 125, 25, 1) solid;
        }
        .input .input-container {
          display: flex;
          justify-content: space-between;
        }
        #invoice-summary-container .form-input-container #total-amount {
          font-size: 20px;
          border-top: 1px rgba(25, 125, 25, 1) solid;
          color: white;
          text-align: right;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function CustomerDetailsFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #customer-details-container {
          display: flex;
          padding: 5px;
          /*flex: 3;*/
          /*width: 70%;*/
        }

        .customer-details-container-background {
          background-color: rgba(122, 122, 122, 0.3)
        }

        .form-container { flex: 2; }
        #button-hide-customer-details-container {
          flex: 1;
          padding: 5px;
          text-align: right;
        }

        .hide-btn {
          color: rgba(22, 22, 22, 1);
          background-color: transparent;
          padding: 3px;
          border: none;
        }
        .hide-btn:hover {
          color: whitesmoke;
          border: none;
        }

        #customer-details-container
        .form-input-container
        .input-container {
          flex: 3;
          display: flex;
          flex-direction: column;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function InvoiceInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .reset-invoice-btn {
          color: white;
          background-color: #34568B;
        }
        .reset-invoice-btn:hover {
          color: white;
          background-color: #356A92;
        }

        #invoices-container {
          height: 100%;
          display: grid;
          font-size: 0.65em;
          grid-template-columns: 1fr;
          grid-template-rows: auto 1fr;
          grid-template-areas:
              "header"
              "body";
        }
        .header-title-container {
          display: flex;
        }
        .header-caption {
          flex: 2;
          margin: 10px 0;
          grid-area: header;
        }
        #invoice-body {
          overflow: auto;
          display: grid;
          grid-area: body;
          grid-template-columns: 4fr 1fr;
          grid-template-rows: 1fr;
          grid-template-areas:
              "left right";
        }
        #invoice-left {
          overflow: auto;
          grid-area: left;
        }
        #invoice-right {
          /*background-color: rgba(242, 242, 242, 0.9);*/
          background-color: rgba(82, 82, 82, 1);
          padding: 10px;
          grid-area: right;
        }

        .form-container input[readOnly] {
          border: solid 1px darkgrey;
          background-color: lightgrey;
        }

        .form-container {
          padding: 3px;
        }
        .form-input-container {
          display: flex;
          margin-bottom: 3px;
        }
        .form-input-container label {
          flex: 1;
          font-weight: bold;
          padding: 5px;
        }
        .form-input-container input {
          flex: 3;
          padding: 5px;
        }

        .acl-container {
          position: relative;
          text-align: left;
          font-size: 16px;
          font-weight: normal;
        }

        #show-customer-link:hover {
          cursor: pointer;
        }

        .expiration-date-container {
          display: flex;
          font-size: 0.75rem;
          background-color: #888;
          border-radius: 5px;
          color: white;
          padding: 3px 6px;
          width: 160px;
          margin-top: 3px;
          text-align: left;
        }
        .item-expiration-date { color: lightgreen; }
      `}
      </style>
    </React.Fragment>
  )
}
